import { useEffect } from 'react';

import LottieView from 'lottie-react-native';
import { StyleSheet } from 'react-native';

import { StaticImages, useStaticLottieUri } from 'components/picture/static-image';
import { Box } from 'components/ui/box';
import { isNative, isWeb } from 'utils/environment';
import { useLottieSource } from 'utils/lottie/use-lottie-source';

import { useConfettiFriesAnimation } from './use-confetti-fries-animation';

const AnimationContainer = ({ children }: React.PropsWithChildren) => (
  <Box style={[styles.animationContainer, isWeb && styles.webAnimationContainer]}>{children}</Box>
);

export const ConfettiFriesAnimation = () => {
  const { isAnimationComplete, setIsAnimationComplete } = useConfettiFriesAnimation();
  const uri = useStaticLottieUri(StaticImages.ConfettiFries);
  const { source, error } = useLottieSource({
    source: uri ? { uri } : undefined,
    surface: 'confetti_fries',
  });

  useEffect(() => {
    if (error) {
      setIsAnimationComplete(true);
    }
  }, [error, setIsAnimationComplete]);

  return (
    !isAnimationComplete &&
    source && (
      <AnimationContainer>
        <LottieView
          autoPlay={true}
          loop={false}
          source={source}
          style={
            isNative
              ? {
                  position: 'absolute',
                  alignSelf: 'center',
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  margin: -50,
                  pointerEvents: 'none',
                }
              : {}
          }
          webStyle={{}}
          onAnimationFailure={() => setIsAnimationComplete(true)}
          onAnimationFinish={() => {
            // Add delay on Native to allow time for the animation to finish
            setTimeout(() => setIsAnimationComplete(true), isNative ? 2000 : 0);
          }}
        />
      </AnimationContainer>
    )
  );
};

const styles = StyleSheet.create({
  animationContainer: {
    height: '100%',
    position: 'absolute',
    width: '100%',
  },
  webAnimationContainer: {
    alignSelf: 'center',
    maxWidth: 600,
  },
});
